import { ComponentPortal } from '@angular/cdk/portal';
import { Overlay } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';
import { ConfettiAnimateComponent } from '../components/confetti-animate/confetti-animate.component';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class AnimationManagerService {
  constructor(private overlay: Overlay) {}

  async runConfetiAnimationAsync(): Promise<void> {
    const portal: ComponentPortal<ConfettiAnimateComponent> = new ComponentPortal(ConfettiAnimateComponent);
    const positionStrategy = this.overlay.position().global().centerVertically().centerHorizontally();
    const overlayRef = this.overlay.create({ positionStrategy, width: '100%', height: '100%' });
    const comonentInstance: ConfettiAnimateComponent = overlayRef.attach(portal).instance;

    try {
      await firstValueFrom(comonentInstance.completeAnimation);
    } finally {
      overlayRef.dispose();
    }
  }
}
